module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-1 grey lighten-4"
  }, [_vm._v("\n    Generate report\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-0",
    attrs: {
      "type": "info",
      "value": true
    }
  }, [_vm._v("\n    This will load a print friendly report which you can either print, or save as a pdf.\n\n    "), _c('li', [_c('strong', [_vm._v("To print")]), _vm._v(": In your browser, click file -> print (or cmd/ctrl P)")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("To save as PDF")]), _vm._v(": From the print dialog, select save as PDF as your destination")])]), _vm._v(" "), _c('v-card-text', [(_vm.withTitle) ? _c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), (_vm.withDates) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.withDates = false;
        _vm.fromDate = null;
        _vm.toDate = null;
      }
    }
  }, [_vm._v("Clear date range\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("cancel")])], 1) : _c('v-btn', {
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.withDates = true
      }
    }
  }, [_vm._v("Add date range")])], 1), _vm._v(" "), (_vm.withDates) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("From date")]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "max": _vm.toDate,
      "full-width": "",
      "type": "month"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("To date")]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "min": _vm.fromDate,
      "full-width": "",
      "type": "month"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "target": "_blank",
      "href": _vm.reportUrl
    }
  }, [_vm._v("\n      Show report\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ed338d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/forms/ReportForm.vue
// module id = 1341
// module chunks = 9